export default __webpack_public_path__ + "static/media/playlistPlaceholder.0234da1c.png";